import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconSettings = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 22,
	height: 22,
	viewBox: "0 0 32 32",
	fill: "currentColor",
	...props,
	children: [/* @__PURE__ */ _jsx("path", { d: "M22,1H10C6.1,1,3,4.1,3,8s3.1,7,7,7h12c3.9,0,7-3.1,7-7S25.9,1,22,1z M22,12c-2.2,0-4-1.8-4-4s1.8-4,4-4s4,1.8,4,4S24.2,12,22,12z" }), /* @__PURE__ */ _jsx("path", { d: "M22,17H10c-3.9,0-7,3.1-7,7s3.1,7,7,7h12c3.9,0,7-3.1,7-7S25.9,17,22,17z M10,28c-2.2,0-4-1.8-4-4s1.8-4,4-4s4,1.8,4,4S12.2,28,10,28z" })]
});
export default SvgIconSettings;
